export const listItemButtonSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
};

export const listItemTextSlopProps = {
    primary: {
        sx: {
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            overflow: 'hidden',
        },
    },
};

export const listItemTextSx = {
    width: '100%',
};
